import { ScopeT } from 'business/definitions';
import { AlertFilter } from 'lib/alert/models';
import { getTableName } from 'helpers/helpers';
import { getBlocks, isAllExpression, isAnyExpression } from 'helpers/scopes';

/**
 * Check if a scope expression is fulfilled.
 * @param scope - the scope to check.
 * @param filters - the list of current filter.
 */
export const isScopeFulfilled = (
    scope: ScopeT,
    filters: AlertFilter[],
): boolean => {
    if (scope.expression === undefined) {
        return false;
    }
    const blocks = getBlocks(scope);
    const filtersTableNames = filters.map((filter) =>
        getTableName(filter.field),
    );
    const filtersValues = filters.map((filter) => filter.value);

    // Function to check if a block exists in the filters and is properly protected
    const isBlockFulfilled = (block: string) => {
        const index = filtersTableNames.indexOf(block);
        return index !== -1 && filtersValues[index] === `scope:${scope.name}`;
    };

    if (isAnyExpression(scope.expression) && scope.expression.any) {
        return blocks.some(isBlockFulfilled);
    }
    if (isAllExpression(scope.expression) && scope.expression.all) {
        return blocks.every(isBlockFulfilled);
    }
    const filtersFields = filters.map((f) => f.field);
    return (
        scope.expression.block !== undefined &&
        filtersFields.includes(scope.expression.block)
    );
};
